import { render } from "./SleepingCoursesView.vue?vue&type=template&id=2b812896&scoped=true"
import script from "./SleepingCoursesView.vue?vue&type=script&lang=js"
export * from "./SleepingCoursesView.vue?vue&type=script&lang=js"

import "./SleepingCoursesView.vue?vue&type=style&index=0&id=2b812896&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b812896"]])

export default __exports__